/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Skill_OverlineInputs */

const en_mk_skill_overline = /** @type {(inputs: Mk_Skill_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 · Skill Packs`)
};

const id_mk_skill_overline = /** @type {(inputs: Mk_Skill_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 · Skill Pack`)
};

/**
* | output |
* | --- |
* | "02 · Skill Packs" |
*
* @param {Mk_Skill_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_skill_overline = /** @type {((inputs?: Mk_Skill_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Skill_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_skill_overline(inputs)
	return en_mk_skill_overline(inputs)
});